module.exports = __webpack_public_path__ + "img/acct-value.a5e8b285.svg";